import * as types from '../../action-types';
import { updateContact as initialState } from "../../initialState";

const updateContact = (state=initialState, action) => {
  switch (action.type) {
    case types.UPDATE_CONTACT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_CONTACT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.UPDATE_CONTACT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPDATE_CONTACT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default updateContact;
